/* GUMÉA PARIS — gumea.js v3 */
(function(){
'use strict';

/* ── Utility ── */
function fmt(cents){
  return (cents/100).toFixed(2).replace('.',',') + '\u00a0\u20ac';
}
function qs(sel, ctx){ return (ctx||document).querySelector(sel); }
function qsa(sel, ctx){ return (ctx||document).querySelectorAll(sel); }

/* ── Toast ── */
var toastEl;
window.gmToast = function(msg){
  if(!toastEl){
    toastEl = document.createElement('div');
    toastEl.className = 'gm-toast';
    document.body.appendChild(toastEl);
  }
  toastEl.textContent = msg;
  toastEl.classList.add('gm-show');
  clearTimeout(toastEl._t);
  toastEl._t = setTimeout(function(){ toastEl.classList.remove('gm-show'); }, 2800);
};

/* ── Cart API ── */
async function gmFetchCart(){
  var r = await fetch('/cart.js');
  return r.json();
}

async function gmRenderCart(){
  var cart = await gmFetchCart();

  /* Badge — Guméa + Dawn/Prestige selectors */
  var count = cart.item_count;
  qsa('.gm-cart-count,[data-cart-count],.cart-count,[data-header-cart-count],.js-cart-count,.header__cart-count,.cart__count-bubble').forEach(function(el){
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  });

  /* Shipping bar */
  var bar   = qs('#gm-shipping-bar');
  var fill  = qs('#gm-shipping-fill');
  var msg   = qs('#gm-shipping-msg');
  var pctEl = qs('#gm-shipping-pct');
  var upsell = qs('#gm-upsell-block');
  if(bar){
    var threshold = parseInt(bar.dataset.threshold || 4900);
    bar.style.display = count > 0 ? 'block' : 'none';
    var rem = Math.max(0, threshold - cart.total_price);
    var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
    if(fill) fill.style.width = pct + '%';
    if(pctEl) pctEl.textContent = pct + '%';
    if(msg){
      if(rem <= 0){
        var completeText = bar.dataset.messageComplete || 'Livraison offerte !';
        msg.innerHTML = '<strong style="color:var(--gm-rose)">' + completeText + '</strong>';
        if(fill) fill.style.background = '#16a34a';
      } else {
        var e = (rem/100).toFixed(2).replace('.',',') + '\u00a0\u20ac';
        var remainingTemplate = bar.dataset.messageRemaining || 'Plus que [montant] pour la livraison offerte';
        msg.innerHTML = remainingTemplate.replace('[montant]', '<strong>' + e + '</strong>');
        if(fill) fill.style.background = 'var(--gm-rose)';
      }
    }
  }
  if(upsell) upsell.style.display = count > 0 ? 'flex' : 'none';

  /* Cart body */
  var body = qs('#gm-cart-body');
  var totalEl = qs('#gm-cart-total');
  if(!body) return;

  if(count === 0){
    var d = body.dataset;
    body.innerHTML = '<div class="gm-cart-empty"><div class="gm-cart-empty__icon">\uD83D\uDED2</div><div class="gm-cart-empty__title">' + (d.emptyTitle || '') + '</div><p class="gm-cart-empty__text">' + (d.emptyText || '') + '</p><a href="' + (d.emptyCtaUrl || '/collections/all') + '" class="gm-btn gm-btn-primary" onclick="gmCloseCart()">' + (d.emptyCtaLabel || '') + '</a></div>';
    if(totalEl) totalEl.textContent = '0,00\u00a0\u20ac';
    return;
  }

  var html = '';
  cart.items.forEach(function(item){
    html += '<div class="gm-ci" data-key="' + item.key + '">'
      + '<img class="gm-ci__img" src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">'
      + '<div class="gm-ci__info">'
      + '<div class="gm-ci__name">' + item.product_title + '</div>'
      + '<div class="gm-ci__var">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>'
      + '<div class="gm-ci__row">'
      + '<div class="gm-qty">'
      + '<button class="gm-qty__btn" onclick="gmQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Diminuer">\u2212</button>'
      + '<span class="gm-qty__n" aria-live="polite">' + item.quantity + '</span>'
      + '<button class="gm-qty__btn" onclick="gmQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Augmenter">+</button>'
      + '</div>'
      + '<span class="gm-ci__price">' + fmt(item.final_line_price) + '</span>'
      + '</div></div></div>';
  });
  body.innerHTML = html;
  if(totalEl) totalEl.textContent = fmt(cart.total_price);
}

window.gmQty = async function(key, qty){
  await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,qty)})});
  gmRenderCart();
};

window.gmAdd = async function(variantId, qty, btn){
  if(!variantId) return;
  if(btn){ btn.classList.add('gm-loading'); btn.disabled = true; }
  try {
    var r = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:qty||1})});
    if(!r.ok) throw new Error();
    await gmRenderCart();
    gmOpenCart();
    gmToast('Ajout\u00e9 au panier\u00a0!');
  } catch(e) {
    gmToast('Erreur\u00a0: veuillez r\u00e9essayer');
  } finally {
    if(btn){ btn.classList.remove('gm-loading'); btn.disabled = false; }
  }
};

window.gpBuyNow = async function(variantId, qty, btn){
  if(!variantId) return;
  if(btn){ btn.classList.add('gm-loading'); btn.disabled = true; }
  try {
    await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:qty||1})});
    window.location.href = '/checkout';
  } catch(e) {
    if(btn){ btn.classList.remove('gm-loading'); btn.disabled = false; }
    gmToast('Erreur');
  }
};

/* ── Drawer ── */
window.gmOpenCart = function(){
  var d = qs('#gm-cart-drawer');
  var o = qs('#gm-overlay');
  if(d) d.classList.add('gm-open');
  if(o) o.classList.add('gm-open');
  document.body.style.overflow = 'hidden';
};
window.gmCloseCart = function(){
  var d = qs('#gm-cart-drawer');
  var o = qs('#gm-overlay');
  if(d) d.classList.remove('gm-open');
  if(o) o.classList.remove('gm-open');
  document.body.style.overflow = '';
};

/* ── Cure Selector ── */
document.addEventListener('click', function(e){
  var opt = e.target.closest('.gm-cure-opt');
  if(!opt) return;
  var sel = opt.closest('.gm-cure-sel');
  if(!sel) return;
  qsa('.gm-cure-opt', sel).forEach(function(o){ o.classList.remove('gm-on'); o.setAttribute('aria-pressed','false'); });
  opt.classList.add('gm-on');
  opt.setAttribute('aria-pressed','true');
  var months = opt.dataset.months;

  /* Price update */
  var priceEl = qs('.gm-pdp__price');
  var oldEl   = qs('.gm-pdp__price-old');
  var perEl   = qs('.gm-pdp__per-day');
  if(priceEl){
    var prices   = JSON.parse(priceEl.dataset.prices   || '{}');
    var compares = JSON.parse(priceEl.dataset.compares || '{}');
    var perDays  = JSON.parse(priceEl.dataset.perdays  || '{}');
    if(prices[months]){
      priceEl.textContent = prices[months];
      priceEl.classList.remove('gm-flip');
      void priceEl.offsetWidth;
      priceEl.classList.add('gm-flip');
    }
    if(oldEl) oldEl.style.display = compares[months] ? '' : 'none';
    if(oldEl && compares[months]) oldEl.textContent = compares[months];
    if(perEl && perDays[months]) perEl.textContent = perDays[months];
  }

  /* Variant map */
  var mapEl = qs('#gm-variant-map');
  if(mapEl){
    var vmap = JSON.parse(mapEl.dataset.map || '{}');
    var vid  = vmap[months];
    if(vid){
      var atcBtn = qs('[data-gm-atc]');
      var bnBtn  = qs('[data-gm-bn]');
      var stickyBtn = qs('#gm-sticky-btn');
      if(atcBtn){ atcBtn.onclick = function(){ gmAdd(vid,1,this); }; }
      if(bnBtn){  bnBtn.onclick  = function(){ gpBuyNow(vid,1,this); }; }
      if(stickyBtn){ stickyBtn.onclick = function(){ gmAdd(vid,1,this); }; }
    }
  }

  /* Sticky price */
  var stickyPriceEl = qs('#gm-sticky-price');
  if(stickyPriceEl && priceEl){
    var pp = JSON.parse(priceEl.dataset.prices || '{}');
    if(pp[months]) stickyPriceEl.textContent = pp[months] + ' / cure ' + months + ' mois';
  }
});

/* ── FAQ Accordion ── */
document.addEventListener('click', function(e){
  var q = e.target.closest('.gm-faq__q');
  if(!q) return;
  var open = q.getAttribute('aria-expanded') === 'true';
  q.setAttribute('aria-expanded', String(!open));
  var body = q.nextElementSibling;
  if(body) body.classList.toggle('gm-open', !open);
});

/* ── Gallery Thumbs ── */
document.addEventListener('click', function(e){
  var thumb = e.target.closest('.gm-pdp__thumb, .gm-pdp__desk-thumb');
  if(!thumb) return;
  var isMob  = thumb.classList.contains('gm-pdp__thumb');
  var gallery = isMob
    ? qs('.gm-pdp__gallery-mob')
    : qs('.gm-pdp__gallery-desk');
  if(!gallery) return;
  var sel = isMob ? '.gm-pdp__thumb' : '.gm-pdp__desk-thumb';
  qsa(sel, gallery).forEach(function(t){ t.classList.remove('gm-on'); });
  thumb.classList.add('gm-on');
  var mainImg = isMob ? qs('.gm-pdp__main img') : qs('.gm-pdp__desk-main img');
  if(mainImg){
    var src = thumb.querySelector('img');
    if(src) mainImg.src = src.src.replace('_small','').replace('_medium','').replace('_large','').replace('_compact','');
  }
});

/* ── Cures Tab Switcher ── */
document.addEventListener('click', function(e){
  var tab = e.target.closest('.gm-cure-tab');
  if(!tab) return;
  var container = tab.closest('[data-cures-section]');
  if(!container) return;
  qsa('.gm-cure-tab', container).forEach(function(t){ t.classList.remove('gm-on'); t.setAttribute('aria-selected','false'); });
  tab.classList.add('gm-on');
  tab.setAttribute('aria-selected','true');
  var target = tab.dataset.tab;
  qsa('.gm-cure-panel', container).forEach(function(p){
    var active = p.dataset.panel === target;
    p.classList.toggle('gm-on', active);
    p.hidden = !active;
  });
});

/* ── Scroll Reveal ── */
function initReveal(){
  if(!('IntersectionObserver' in window)){
    qsa('.gm-rv').forEach(function(el){ el.classList.add('gm-in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('gm-in'); io.unobserve(e.target); }
    });
  },{threshold:0.07, rootMargin:'0px 0px -24px 0px'});
  qsa('.gm-rv').forEach(function(el, i){
    el.style.transitionDelay = (i % 5) * 0.08 + 's';
    io.observe(el);
  });
}

/* ── Countdown ── */
window.gmCountdown = function(endMs){
  function pad(n){ return String(n).padStart(2,'0'); }
  function tick(){
    var diff = endMs - Date.now();
    if(diff <= 0){ clearInterval(iv); return; }
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var eh = qs('#gm-cd-h'), em = qs('#gm-cd-m'), es = qs('#gm-cd-s');
    if(eh) eh.textContent = pad(h);
    if(em) em.textContent = pad(m);
    if(es) es.textContent = pad(s);
  }
  tick();
  var iv = setInterval(tick, 1000);
};

/* ── Sticky ATC ── */
function initStickyAtc(){
  var mainAtc = qs('[data-gm-atc]');
  var bar     = qs('#gm-sticky-atc');
  if(!mainAtc || !bar) return;
  if(!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    bar.classList.toggle('gm-show', !entries[0].isIntersecting);
  }, {threshold:0});
  io.observe(mainAtc);
}

/* ── Urgency widgets ── */
function initUrgency(){
  var vEl  = qs('[data-gm-viewers]');
  var sEl  = qs('[data-gm-stock]');
  var sFill = qs('#gm-stock-fill');
  if(vEl){
    var v = 8 + Math.floor(Math.random() * 14);
    vEl.innerHTML = '<strong>' + v + ' personnes</strong> regardent ce produit en ce moment';
  }
  if(sEl){
    var s = 5 + Math.floor(Math.random() * 11);
    var pct = Math.round(s / 40 * 100);
    sEl.innerHTML = 'Il reste <strong style="color:var(--gm-pdp-acc,var(--gm-rose))">' + s + ' unit\u00e9s</strong>';
    if(sFill){ sFill.style.width = pct + '%'; }
  }
}

/* ── CTA Shake ── */
function initShake(){
  var atcBtn = qs('[data-gm-atc]');
  if(!atcBtn || window.matchMedia('(min-width:768px)').matches) return;
  var timer = setTimeout(function(){
    if(document.hidden) return;
    atcBtn.style.animation = 'gm-shake .5s ease';
    setTimeout(function(){ atcBtn.style.animation = ''; }, 600);
  }, 8000);
}

/* ── Init ── */
document.addEventListener('DOMContentLoaded', function(){
  gmRenderCart();
  initReveal();
  initStickyAtc();
  initUrgency();
  initShake();

  /* Overlay click */
  var overlay = qs('#gm-overlay');
  if(overlay) overlay.addEventListener('click', gmCloseCart);

  /* Open cart triggers */
  qsa('[data-gm-open-cart]').forEach(function(btn){
    btn.addEventListener('click', function(e){ e.preventDefault(); gmOpenCart(); });
  });

  /* Default cure = 3 months */
  qsa('.gm-cure-opt[data-months="3"]').forEach(function(opt){
    opt.classList.add('gm-on');
    opt.setAttribute('aria-pressed','true');
    var sel = opt.closest('.gm-cure-sel');
    if(sel) qsa('.gm-cure-opt:not([data-months="3"])', sel).forEach(function(o){ o.classList.remove('gm-on'); o.setAttribute('aria-pressed','false'); });
  });

  /* Countdown on cures page */
  var cdEl = qs('[data-gm-countdown]');
  if(cdEl){
    var end = new Date(); end.setHours(23,59,59,999);
    gmCountdown(end.getTime());
  }

  /* Banner dismiss */
  qsa('.gm-banner__close').forEach(function(btn){
    btn.addEventListener('click', function(){
      var banner = btn.closest('.gm-banner');
      if(banner) banner.style.display = 'none';
    });
  });
});

})();
